export default __webpack_public_path__ + "static/white_cat-d196cd592326cf98e6892ca615cae42c.jpg";